import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Settings.css';

const Settings = () => {
  const { supabase, user, refreshProfile } = useAuth();
  const [fullName, setFullName] = useState(user?.profile?.full_name || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  // Update local state when user profile changes
  useEffect(() => {
    if (user?.profile?.full_name) {
      setFullName(user.profile.full_name);
    }
  }, [user?.profile?.full_name]);

  const handleUpdateName = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const { error } = await supabase
        .from('user_profiles')
        .update({ full_name: fullName })
        .eq('id', user.id);

      if (error) throw error;

      // Wait a bit for the database to update
      await new Promise(resolve => setTimeout(resolve, 100));

      // Refresh the user profile in AuthContext to update the UI
      await refreshProfile();

      // Update local state to reflect the change immediately
      setFullName(fullName);

      setSuccess('Naam succesvol bijgewerkt');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error updating name:', err);
      setError(err.message || 'Fout bij bijwerken van naam');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('Nieuwe wachtwoorden komen niet overeen');
      return;
    }

    if (newPassword.length < 6) {
      setError('Wachtwoord moet minimaal 6 tekens lang zijn');
      return;
    }

    setLoading(true);

    try {
      // Update password using Supabase Auth
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });

      if (error) throw error;

      setSuccess('Wachtwoord succesvol bijgewerkt');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error updating password:', err);
      setError(err.message || 'Fout bij bijwerken van wachtwoord');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-container">
      <h1>Instellingen</h1>
      
      <div className="settings-content">
        <div className="settings-section">
          <h2>Profiel</h2>
          <form onSubmit={handleUpdateName} className="settings-form">
            <div className="form-group">
              <label htmlFor="fullName">Volledige naam</label>
              <input
                id="fullName"
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Uw volledige naam"
                required
              />
            </div>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Bijwerken...' : 'Naam bijwerken'}
            </button>
          </form>
        </div>

        <div className="settings-section">
          <h2>Wachtwoord wijzigen</h2>
          <form onSubmit={handleUpdatePassword} className="settings-form">
            <div className="form-group">
              <label htmlFor="newPassword">Nieuw wachtwoord</label>
              <input
                id="newPassword"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Nieuw wachtwoord"
                required
                minLength={6}
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmPassword">Bevestig nieuw wachtwoord</label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Bevestig nieuw wachtwoord"
                required
                minLength={6}
              />
            </div>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Bijwerken...' : 'Wachtwoord bijwerken'}
            </button>
          </form>
        </div>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
      </div>
    </div>
  );
};

export default Settings;

